module.exports = __webpack_public_path__ + "static/media/education-3.ae5ac12b.png";